module.exports = __webpack_public_path__ + "static/img/9.e628ac4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/9.png
// module id = cKA7
// module chunks = 0